import React from 'react';

import {
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonList,
} from '@ionic/react';

import FRItem from 'scenes/FinancePage/FR/Item';
import IOItem from 'scenes/FinancePage/IO/Item';
import SAItem from 'scenes/FinancePage/SA/Item';
import { TYPE_FR, TYPE_IO, TYPE_SA } from 'scenes/FinancePage/constants';

export default ({ data, onIonInfinite, isInfiniteDisabled }: any) => {
  return (
    <>
      <IonList lines={'full'}>
        {data.pages.map((page: any, pageIndex: number) => {
          return page.rows.map((item: any, index: number) => {
            let RenderComponent: any = null;
            switch (item?.type?.id) {
              case TYPE_FR:
                RenderComponent = FRItem;
                break;
              case TYPE_IO:
                RenderComponent = IOItem;
                break;
              case TYPE_SA:
                RenderComponent = SAItem;
                break;
            }
            return RenderComponent ? (
              <RenderComponent item={item} key={`${pageIndex}_${index}`} />
            ) : (
              <b key={`${pageIndex}_${index}`}>
                Uncorrected type: {JSON.stringify(item?.type)}
              </b>
            );
          });
        })}
      </IonList>
      <IonInfiniteScroll
        onIonInfinite={onIonInfinite}
        threshold={'100px'}
        disabled={isInfiniteDisabled}
      >
        <IonInfiniteScrollContent loadingSpinner={'crescent'} />
      </IonInfiniteScroll>
    </>
  );
};
